import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { tap, switchMap } from 'rxjs/operators';

import { SkeletonUnsubscribeService } from './services/skeleton-unsubscribe.service';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'app-unsubscribe-successful',
  templateUrl: './unsubscribe-successful.component.html',
  styleUrls: ['./unsubscribe-successful.component.css']
})
export class UnsubscribeSuccessfulComponent implements OnInit {

  website = window.location.host;
  token: string;

  private readonly isAccountApplicationMode = AppConfig.getAccountMode;
  private readonly accountModeUrl = AppConfig.getAccountModeUrl;

  constructor(
    private route: ActivatedRoute,
    private unsubscribeService: SkeletonUnsubscribeService,
    private router : Router) { }

  ngOnInit() {
    this.route.params.pipe(
      tap(params => this.token = params.token),
      switchMap(() => this.unsubscribeService.oneClickUnsubscribe(this.token))
    ).subscribe(res => console.log('UNSUBSCRIBED'));
  }

  navigateToSearchPage() {
    const searchPageUrl: string = '/search';
    this.isAccountApplicationMode ?
        document.location.href = this.accountModeUrl + 'search' :
        this.router.navigate([searchPageUrl]);
  }

}
